import SuperSearchList from '../../../../shared/SuperSearch/SuperSearchList';
import { enumUtil } from '../../../../../utils/Enum';
import isNull from '../../../../../utils/NullChecking';
import { useEffect, useState } from 'react';
import ContentReceiver from '../../../ContentReceiverNewBrowserTab/ContentReceiver';
import useOpenTab from './useOpenTab';

const TopNavInstantSearch = ({selectedSearch,setIsFocused, focused}) => {

    // To Set Type of Global Action on the basis of Selected Type
    let actionData = `${selectedSearch=== "Patient" ? "PatientSearch" : selectedSearch=== "Profile" ? "Profiles": selectedSearch}`;
    let searchValueMinChar = selectedSearch === "Profile" ? 2 : 3;
    const API_URL_GENERAL = enumUtil.controller.General;
    const [is, setIs] = useState(false);
    const [searchGlobalName, setSearchGlobalName] = useState('')
    const [globalSearchBody, setGlobalSearchBody] = useState({
        "TableName": enumUtil.enumAPITableName.GlobalSearch,
        "SearchCriteria": {
            "Action": actionData, 
            "Search":""
        },
    });

    // Custom hook "useOpenTab" returns states and functions required to open Components
    const { openTab, setOpenTab, popup, OpenPatient, OpenClaim, OpenPayment, handleOpenQuickPopup} = useOpenTab();

    // Changes to apply on type change of global search 
    useEffect(() => {
        setGlobalSearchBody({...globalSearchBody,"SearchCriteria" :{"Action": actionData ,"Search":''} })
    },[selectedSearch])

    // On Change function
    const handleGlobalSearchChange = (e) => {
        setIs(false)
        let { name, value } = e.target;
        if (name === "GlobalDataID") {
            setSearchGlobalName( value);
        } 
        if(!isNull(value) ){
            setGlobalSearchBody({...globalSearchBody,"SearchCriteria" :{...globalSearchBody['SearchCriteria'] ,"Search":value} })
        }

    }

    // On Selection Function
    const handleGlobalSelectedData = (selectedData, name, type) => {
        setIs(true)
        if (!isNull(selectedData)) {
            if (type === "server") {
                if (name === "GlobalDataID") {
                    handleOpenTab(selectedData);
                }
            }
        } else {
            if (name === "GlobalDataID") {
                setSearchGlobalName('')
            }
        }
        return selectedData;
    };

    // Function to perform actions based on the selected data type
    const handleOpenTab = (selectedData) => {
        console.log("first",selectedData)
        if(selectedData.Type === "Patient"){
            console.log("PatientSelectedData", selectedData)
            OpenPatient(selectedData);
        } else if(selectedData.Type === "Claim"){
            OpenClaim(selectedData);
        } else if(["Manual Payment","ERA Payment"].includes(selectedData.Type)){
            OpenPayment(selectedData);
        } else if(['Location','Provider','RefProvider','POS','Diagnosis','Procedure','Modifier','Insurance'].includes(selectedData.Type)) {
            handleOpenQuickPopup(selectedData);
        }
        setSearchGlobalName('');
    }
    const placeholder = 
    selectedSearch=== "Patient" ? "Search by Name, Subscriber ID, Medicaid #, Address, Phone, Email" :
    selectedSearch=== "Billing" ? "Search by Claim #, Subscriber ID, Check #":
    selectedSearch=== "Profile" ? "Search by NPI, Name, ICD, CPT, POS, Insurance" : "";

    return (<>
        {/* Display Popup */}
        {popup}
        {/* Switch Tab */}
        {openTab ? <ContentReceiver data={openTab} setOpenTab={setOpenTab}/> : <></>}
        {/* Search Field */}
        <div className='form-control fc-xs'>
            <div className="input autocomplete-group autocomplete-group-xs">
              <SuperSearchList
                    GlobalInst= {true}
                    setIsFocused={setIsFocused}
                    focused={focused}
                    searchValueMinChar={searchValueMinChar}
                    type="server"
                    id="GlobalDataID"
                    name="GlobalDataID"
                    searchValue={searchGlobalName}
                    ApiLink={API_URL_GENERAL + "/GlobalSearch"}
                    method="post"
                    postBody={globalSearchBody}
                    onChange={handleGlobalSearchChange}
                    getSelectedData={handleGlobalSelectedData}
                    tableHeight="200px"
                    tableWidth="100%"
                    width="286px"
                    is={is}
                    sup_btn="sup_btn"
                    sup_inp="superSearchVisit"
                    styl={true}
                    placeholder={placeholder}
                  />
            </div>
        </div>
    </>);
}
 
export default TopNavInstantSearch;